export interface FincartPricingTier {
  region: string
  governorates: string[]
  price: number
}

export const FINCART_PRICING: FincartPricingTier[] = [
  {
    region: 'Greater Cairo',
    governorates: ['Cairo', 'Giza'],
    price: 83.95
  },
  {
    region: 'Alexandria',
    governorates: ['Alexandria'],
    price: 90.96
  },
  {
    region: 'Delta & Canal',
    governorates: [
      'Gharbia',
      'Kafr Al sheikh',
      'Menofia',
      'Sharkia',
      'Damietta',
      'Ismailia',
      'Port Said',
      'Suez',
      'Dakahlia',
      'Beheira',
      'Qaliubiya'
    ],
    price: 104.30
  },
  {
    region: 'Upper Egypt 1',
    governorates: ['Beni Suef', 'Fayoum', 'Assiut', 'Minya'],
    price: 115.70
  },
  {
    region: 'Upper Egypt 2',
    governorates: ['Sohag', 'Qena', 'Luxor', 'Aswan'],
    price: 163.07
  },
  {
    region: 'Remote Areas',
    governorates: ['Matrouh', 'North Sinai', 'South Sinai', 'Red Sea', 'New Valley'],
    price: 171.05
  }
]

/**
 * Get the Fincart minimum price for a given governorate name
 * @param governorateName The name of the governorate
 * @returns The minimum Fincart price or null if not found
 */
export function getFincartPriceForGovernorate(governorateName: string): number | null {
  if (!governorateName) return null

  const govLower = governorateName.toLowerCase()

  for (const tier of FINCART_PRICING) {
    const match = tier.governorates.find(
      (g) => g.toLowerCase() === govLower || g.toLowerCase().includes(govLower) || govLower.includes(g.toLowerCase())
    )
    if (match) {
      return tier.price
    }
  }

  return null
}

/**
 * Check if a shipping price is below the Fincart minimum
 * @param governorateName The name of the governorate
 * @param shippingPrice The client's shipping price
 * @returns Object with warning info or null if no warning needed
 */
export function checkPriceWarning(
  governorateName: string,
  shippingPrice: string | number
): { fincartPrice: number; difference: number } | null {
  const fincartPrice = getFincartPriceForGovernorate(governorateName)
  if (fincartPrice === null) return null

  const price = typeof shippingPrice === 'string' ? parseFloat(shippingPrice) : shippingPrice

  if (isNaN(price) || price === 0) return null

  if (price < fincartPrice) {
    return {
      fincartPrice,
      difference: fincartPrice - price
    }
  }

  return null
}

/**
 * Get all pricing tiers for display in a popup
 * @returns Array of pricing tiers
 */
export function getAllPricingTiers(): FincartPricingTier[] {
  return FINCART_PRICING
}
